import IconClose from '@/components/icons/IconClose.vue';

export default {
  name: 'MainSidebar',
  components: { IconClose },
  props: {},
  emits: ['close'],
  created() {},
  mounted() {},
  computed: {},
  methods: {
    onCloseSidebar() {
      document.getElementById('html').classList.remove('hide');
      this.$emit('close');
    }
  }
};
